// Uses Bootstrap classes only (no JS logic needed)
// Make sure Bootstrap CSS + JS (or bundle) is loaded in your app.

const SiteHeader = ({ current = "home", brand = "Καΐπη Μαρία" }) => {
  // helper to mark active page
  const isActive = (key) => (current === key ? "active" : "");

  return (
    <header>
      <nav
        className="navbar navbar-expand-lg navbar-dark fixed-top navbar-glass"
        role="navigation"
        aria-label="Main"
      >
        <div className="container">
          <a className="navbar-brand fw-bold" href="/">
            {brand}
          </a>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navItems"
            aria-controls="navItems"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>

          <div
            className="collapse navbar-collapse justify-content-end"
            id="navItems"
          >
            <ul className="navbar-nav gap-2 align-items-lg-center">
              <li className="nav-item">
                <a className={`nav-link ${isActive("home")}`} href="/">
                  Αρχική
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link ${isActive("about")}`}
                  href="/About"
                >
                  Η Ιστορία μου
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link ${isActive("tournaments")}`}
                  href="/Tournaments"
                >
                  Τουρνουά
                </a>
              </li>
              <li className="nav-item">
                <a className="btn btn-light btn-sm ms-lg-2" href="/Support">
                  Στήριξε
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default SiteHeader;
